import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import styled from "styled-components";
import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import { setOpen } from '../../store/openSlice';


const Header = ({ theme, background }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isLinkHovered, setIsLinkHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSide = () => {
    setIsOpen(!isOpen);
    dispatch(setOpen(isOpen));
  };

  const handleLinkMouseOver = () => {
    setIsLinkHovered(true);
  };

  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };
  return (
    <HeaderWrap theme={isOpen ? 'white' : theme} className={`header ${theme} ${location.pathname === '/portfolio/' ? 'port-header' : ''}`} background={background}>
      <h1 onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link' : ''}
        onClick={() => {
          if (isOpen) {
            toggleSide();
          }
        }}>
        <a href="/#sec1" >
          <Logo width="140" height="40" />
        </a>
      </h1>
      <button type='button' onClick={toggleSide} onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isOpen ? 'on hamburgerBtn' : (isLinkHovered ? 'hovered-link hamburgerBtn' : 'hamburgerBtn')}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={isOpen ? 'open menuBox' : 'menuBox'}>
        <ul id="gnb">
          <li>
            <a href="/#sec2"
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
              onClick={toggleSide}
              className={isLinkHovered ? 'hovered-link' : ''}
            >
              About
            </a>
          </li>
          <li>
            <a href="/#sec3"
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
              onClick={toggleSide}
              className={isLinkHovered ? 'hovered-link' : ''}
            >
              Work
            </a>
          </li>
          <li>
            <a href="/contact"
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
              onClick={toggleSide}
              className={isLinkHovered ? 'hovered-link' : ''}
            >
              Contact
            </a>
          </li>
          <li className="file-down-box">
            <a href="/assets/file/topping_사업소개서.pdf"
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
              download
              className={`file-down ${isLinkHovered ? 'hovered-link' : ''}`}>
              <div>회사소개서</div>
              <img src="/assets/icon/download.svg" alt="download" />
            </a>
          </li>
        </ul>
      </div>
    </HeaderWrap>

  );
};

const HeaderWrap = styled.div`
  position:fixed;
  left:50%;
  top:0;
  transform:translateX(-50%);
  z-index:10;
  padding:60px 50px;
  display:flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: ${props => props.background === 'background' ? 'rgba(0, 0, 0, 0.20)' : 'transparent'};
  backdrop-filter: ${props => props.background === 'background' ? 'blur(10px)' : 'unset'};
  svg{
    path{
      fill: ${props => props.theme === 'white' ? '#fff' : '#000'};
    }
  }
  .hamburgerBtn{
    width: 28px;
    height: 20px;
    position: relative;
    overflow: hidden;
    span{
      width: 100%;
      height: 4px;
      background-color:${props => props.theme === 'white' ? '#fff' : '#000'};
      border-radius: 10px;
      position: absolute;
      left: 0;
      transition: all 0.3s;
      transition: 0.25s top 0.25s, 0.25s transform;
      &:nth-of-type(1){
        top:0;
      }
      &:nth-of-type(2){
        top:50%;
        transform: translateY(-50%);
      }
      &:nth-of-type(3){
        top:calc(100% - 4px);
      }
    }
    &.on{
      span{
        transition: 0.25s top, 0.25s transform 0.25s;
        &:nth-of-type(1){
          top:50%;
        transform: translateY(-50%) rotate(45deg);
      }
      &:nth-of-type(2){
        transform: translateY(-50%) rotate(45deg);
      }
      &:nth-of-type(3){
        top: 50%;
        transform: translateY(-50%) rotate(-45deg);
      }
      }
    }
  }
  .menuBox{
    &.open{
      opacity: 1;
      visibility: visible;
    }
    visibility: hidden;
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
    background-color: #000;
    width: 100%;
    height: 100vh;
    align-items: center;
    justify-content: center ;
    opacity: 0;
    transition: .3s ease-out;
    ul{
      text-align: center;
      li{
        a{
          color: #fff;
        }
        font-size: 90px;
        font-weight: 900;
        line-height: 120.9%; 
        margin-bottom:50px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
  }


`

export default Header;